import apiSportsClubs from '@/api/sports-clubs'
import {isEmpty, isNil, pipe, propOr, reject, unless} from 'ramda'

const state = {
  isLoading: false,
  sportsClubs: [],
  validationErrors: null,
  isSubmitting: false,
  total: null,
  lastPage: null,
}

export const mutationTypes = {
  getSportClubsStart: '[sportsClubs more] getSportClubsStart',
  getSportClubsSuccess: '[sportsClubs more] getSportClubsSuccess',
  getSportClubsFailure: '[sportsClubs more] getSportClubsFailure',

  sportsClubsClear: '[sportsClubs more] clear list',
}

export const actionType = {
  getSportClubs: '[sportsClubs more] getSportClubs',
}

const mutations = {
  [mutationTypes.getSportClubsStart](state) {
    state.isLoading = true
    state.validationErrors = null
  },

  [mutationTypes.getSportClubsSuccess](state, payload) {
    if (payload.isAdd) {
      state.sportsClubs = [...(state.sportsClubs || []), ...payload.data]
    } else {
      state.sportsClubs = payload.data
    }
    state.isLoading = false
    state.total = payload.total
    state.lastPage = payload.lastPage
  },

  [mutationTypes.getSportClubsFailure](state, payload) {
    state.isLoading = false
    state.validationErrors = payload
  },

  [mutationTypes.sportsClubsClear](state) {
    state.sportsClubs = []
  },
}

const actions = {
  [actionType.getSportClubs](context, data) {
    const params = pipe(
      propOr(null, 'params'),
      unless(isNil, reject(isEmpty))
    )(data)

    const isAdd = propOr(false, 'isAdd', data)

    context.commit(mutationTypes.getSportClubsStart)
    return new Promise((resolve) => {
      apiSportsClubs
        .getSportClubsMore(params)
        .then((response) => {
          context.commit(mutationTypes.getSportClubsSuccess, {
            ...response.data,
            isAdd,
          })
          resolve(response.data)
        })
        .catch((result) => {
          context.commit(
            mutationTypes.getSportClubsFailure,
            result.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
